export default {
  ProfileEditCompanyDataTabAccess: 'ProfileEditCompanyDataTabAccess',
  ProfileViewCompanyDataCardAccess: 'ProfileViewCompanyDataCardAccess',
  ProfileViewCompanyDataIndustryTypesAccess: 'ProfileViewCompanyDataIndustryTypesAccess',
};
